import {useContext, useEffect, useState} from 'react';
export type RequestErrorHandler = (error: Error) => any;
import {message} from 'antd';
import useAuth from '../utils/AuthContext';
import {useAxios} from '../utils/AxiosProvider';

export interface IUseGetState<Params, Response> {
  data: Response | undefined;
  errorMessage: string;
  loading: boolean;
  request: (param: Params) => Promise<Response>;
  setData: (data: Response | undefined) => any;
  setErrorMessage: (message: string) => any;
  clearErrorMessage: () => any;
}

export default function useGet<Params, Response>(
  api: string,
  props: {
    defaultParams?: Partial<Params>;
    defaultValue?: Response;
    errorHandler?: RequestErrorHandler;
    successHandler?: (res: Response) => any;
  },
): IUseGetState<Params, Response> {
  const [data, setData] = useState<Response | undefined>(props.defaultValue);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const auth = useAuth();
  const axios = useAxios();
  async function request(params: Params): Promise<Response> {
    try {
      setLoading(true);
      const config = {headers: {}};
      if (auth.token) {
        config.headers = {
          'Application-Token': auth.token,
        };
      }
      const res = await axios.instance.get<Response>(api, {
        params: {
          ...props.defaultParams,
          ...params,
        },
        ...config,
      });
      setData(res.data);
      setLoading(false);
      return Promise.resolve(res.data);
    } catch (e) {
      setErrorMessage(e.message);
      if (props.errorHandler) {
        props.errorHandler(new Error(e.message));
      }
      setLoading(false);
      return Promise.reject(e);
    }
  }

  return {
    data,
    errorMessage,
    loading,
    request,
    setData,
    setErrorMessage,
    clearErrorMessage() {
      setErrorMessage('');
    },
  };
}
